import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

Vue.config.productionTip = false

let baseURL = 'https://accounts.onlineada.com/'; //live URL

if( window.location.host == '10.0.0.175:8081' ){
    baseURL = "https://oadaaccounts.ngrok.io/"; //Dev URL
}
if( window.location.host == 'localhost:8080' ){
    baseURL = "https://oadaaccountss.ngrok.io/"; //Dev URL
}

store.commit('setState',{
    key: 'baseURL',
    value: baseURL,
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
